import { Table } from '@aws-amplify/ui-react'
import { NavBar } from 'components/NavBar/NavBar'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Pagination } from 'components/Pagination/Pagination'
import { Td } from 'components/Td/Td'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Button, Flex, MainHeadline, PageFooter, PageWrapper, Th, Tr } from 'styling/GlobalStyles'
import { formatDateForDisplay, getParams, handlePagination } from 'utils/helpers'
import { InventoryTransferModal } from './InventoryTransferModal'
import { clearInventoryTransfers, getInventoryTransfers } from 'features/inventory/inventoryTransfersSlice'
import { ViewInventoryTransferModal } from './ViewInventoryTransferModal'
import { Options } from 'components/Options/Options'
import { IGetAllInventoryTransfersSingleResponse } from 'types/api/inventoryReceiptsApi.interface'

export const InventoryTransfers = () => {
    const { transfers, totalPages } = useSelector((store: RootState) => store.inventoryTransfers)
    const [params, setParams] = useState<any>(getParams({ location }))
    const [modal, setModal] = useState(false)
    const [viewModal, setViewModal] = useState<{ open: boolean, value: IGetAllInventoryTransfersSingleResponse }>({ open: false, value: null })

    useQueryPagination({ fetchFunctions: [getInventoryTransfers], cleanUpFunctions: [clearInventoryTransfers], params })

    return <>
        <NavBar />
        <PageWrapper>
            <Flex between center mb='16' >
                <MainHeadline>Transfers</MainHeadline>
                <Flex gap='1rem' >
                    <Button orange onClick={() => setModal(true)} >
                        Add Transfer
                    </Button>
                </Flex>

            </Flex>
            {!transfers.length ? (
                <NoItems title='Transfers' />
            ) : (
                <Table width='100%' >
                    <Th >
                        <Td w='15%' noTooltip text='DATE' />
                        <Td w='15%' noTooltip text='ASSIGNED EMPLOYEE' />
                        <Td w='20%' noTooltip text='FROM LOCATION' />
                        <Td w='15%' noTooltip text='TO LOCATION' />
                        <Td w='5%' noTooltip text='ITEMS' />
                        <Td w='25%' noTooltip text='NOTES' />
                        <Td w='5%' noTooltip text='' />
                    </Th>
                    {transfers.map((item) => {
                        return (
                            <Tr key={item.id}>
                                <Td w='15%' text={formatDateForDisplay(item.date, true)} />
                                <Td w='15%' text={item.assignedForUser ? (item.assignedForUser?.firstName + ' ' + item.assignedForUser?.lastName) : '/'} />
                                <Td w='20%' text={item.fromLocation ? item.fromLocation.name : '/'} />
                                <Td w='15%' text={item.toLocation ? item.toLocation.name : '/'} />
                                <Td w='5%' text={item.lines.length || '/'} />
                                <Td w='25%' text={item.notes || '/'} />
                                <Td options w='5%'>
                                    <Options openModal={item => setViewModal({ open: true, value: item })} item={item} title='Inventory Transfers' />
                                </Td>
                            </Tr>
                        )
                    })}
                </Table>
            )}
            {modal && <InventoryTransferModal closeModal={() => setModal(false)} />}
            {viewModal.open && <ViewInventoryTransferModal value={viewModal.value} closeModal={() => setViewModal({ value: null, open: false })} />}
        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}